import React from 'react';
import { ReactComponent as NoImageIcon } from '../../../../assets/img/icons/common/NoImage.svg';
import { useImage } from '../../../../containers/TimersCycle/Frames/hooks';
import Spinner from '../../../Spinner/Spinner';
import '../../styles/Event/EventImage.scss';

const EventImage = ({ url, initialLoading }) => {
  const { src, loading, error } = useImage(url, initialLoading);

  if (loading) {
    return (
      <div className="hp-event-img">
        <div className="hp-event-img-svg">
          <Spinner />
        </div>
      </div>
    );
  }

  return (
    <div className="hp-event-img">
      {error || !src ? (
        <div className="hp-event-img-svg">
          <NoImageIcon className="no-image" />
        </div>
      ) : null}

      {src ? <img src={src} alt="Event" /> : null}
    </div>
  );
};

export default EventImage;
